export const darkColors = () => {
    localStorage.setItem('papercolor', '#101010')
    localStorage.setItem('navcolor', '#222')
    localStorage.setItem('navicon', '#8f8f8f')
    localStorage.setItem('colorsdiv', '#1a1a1a')
    localStorage.setItem('colorsappbar', '#141414')
    localStorage.setItem('statusiconbg', '#e0e0e0')
    localStorage.setItem('statusiconcolor', '#212121')
    localStorage.setItem('iconprimary', '#212121')
    localStorage.setItem('iconsecondary', '#212121')
    localStorage.setItem('pauseiconcolor', '#424242')
    localStorage.setItem('actionplaybg', '#42a5f5')
    localStorage.setItem('actioneditbg', '#ffa726')
    localStorage.setItem('actionremovebg', '#ef5350')
    localStorage.setItem('actioncheckbg', '#66bb6a')
    localStorage.setItem('actionpausebg', '#ffee58')
    localStorage.setItem('removeicn', '#e0e0e0')
    localStorage.setItem('trail', '#6e6e6e')
    localStorage.setItem('warning', '#fdd835')
    localStorage.setItem('delay', '#ef5350')
    localStorage.setItem('projectBox', '#303030')
    localStorage.setItem('primaryDark', '#fafafa')
    localStorage.setItem('primaryLight', '#fafafa')
    localStorage.setItem('menubg', '#212121')
    localStorage.setItem('menutxt', '#fafafa')
    localStorage.setItem('linktxt', '#bdbdbd')
    localStorage.setItem('googlebtncol', '#000000')
    localStorage.setItem('googlebtnbg', '#d86a60')
    localStorage.setItem('kanbantodo', '#ef6c00')
    localStorage.setItem('kanbanprogress', '#1976d2')
    localStorage.setItem('kanbandone', '#388e3c')
    localStorage.setItem('kanbanitem', '#424242')
    localStorage.setItem('kanbantask', '#fafafa')
    localStorage.setItem('buttonbox', 'rgba(0, 0, 0, 0.6)')
}